<div class="d-flex flex-column">
  <form class="search-bar-container">
    <label [for]="controlId" [hidden]="!label">{{ label }}</label>
    <div [style.position]="'relative'">
      <input
        #searchBar
        (input)="searchChanged($event)"
        class="text-field search-text-field"
        [class.error]="hasErrors"
        [class.disabled]="disabled"
        [attr.id]="controlId"
        name="searchBar"
        [disabled]="disabled"
        [readOnly]="!!selectedItem && displayValueInline"
        placeholder="{{ placeHolder }}"
        autocomplete="off"
        type="text" />
      <button
        *ngIf="displayValueInline && (!!selectedItem || searchBar.value.length > 0)"
        class="close"
        type="button"
        aria-label="Clear selection"
        i18n-aria-label
        (click)="clearSelectedItem()"></button>
    </div>
  </form>
  <div
    popper
    [popper]="popperContent"
    [popperShowOnStart]="false"
    [popperTrigger]="NgxPopperjsTriggers.none"
    [popperModifiers]="popperModifier"
    [popperHideOnClickOutside]="false"
    [popperHideOnScroll]="false"
    [popperPreventOverflow]="false"
    [popperTarget]="searchBar"
    [popperPositionFixed]="false"
    [popperApplyClass]="popperClass"
    [popperStyles]="popperStyles"
    [popperPlacement]="NgxPopperjsPlacements.BOTTOM"></div>
  <popper-content #popperContent [style.z-index]="1500" clickOutside (onClickOutside)="handleClickOutside()">
    <div class="loading-container" [hidden]="!(isLoading$ | async)">
      <app-loading [hidden]="!(isLoading$ | async)" [options]="(loadingOptions$ | async) ?? undefined" />
    </div>
    <app-look-ahead-list
      [customItemTemplate]="customItemTemplate"
      [lookAheadItems]="lookAheadItems"
      [lookAheadProperties]="searchedProperties"
      [useProfileItems]="useProfileListItems"
      (lookAheadItemClicked)="itemSelected($event)" />
  </popper-content>
</div>
